/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_OverflowInputs */

const en_us2_past_overflow = /** @type {(inputs: Past_OverflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Overflow`)
};

const en_gb2_past_overflow = /** @type {(inputs: Past_OverflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Spill`)
};

/**
* | output |
* | --- |
* | "Past Overflow" |
*
* @param {Past_OverflowInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const past_overflow = /** @type {((inputs?: Past_OverflowInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_OverflowInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_past_overflow(inputs)
	return en_us2_past_overflow(inputs)
});